<template>
  <div class="d-flex" id="wrapper">
    <div class="border-right-0" id="sidebar-wrapper">
      <UserNavigationSidebar :toggler.sync="isToggled" />

      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar :profile="getUserProfile" />

      <div class="card">
        <section id="search-job" class="mt-5">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div class="ratio ratio-16x9">
                  <iframe
                    src="../../../public/sharkMan/index.html"
                    title="YouTube video"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import TopNavbar from '@/components/Navigations/TopNavbar';
import UserNavigationSidebar from '@/components/Navigations/UserNavigationSidebar';
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [toggleSidebarNav],
  components: {
    UserNavigationSidebar,
    TopNavbar,
  },
  data: () => ({ isToggled: false }),
  methods: {
    ...mapActions(['retrieveCandidateUserProfile']),
    methods: {},
  },
  computed: { ...mapGetters(['getUserProfile']) },
  mounted() {
    this.retrieveCandidateUserProfile();
  },
};
</script>
